import { SplitButton } from 'primereact/splitbutton';
import React from "react";
import { useAuth } from '../AuthProvider'

export default function LogoutButton() {
    // const { keycloak } = useKeycloak();
    const { keycloak } = useAuth();

    const handleLogout = () => {
        keycloak?.logout({
            redirectUri: window.location.origin
        });
    };

    const items = [
        {
            label: 'Log out',
            icon: 'pi pi-sign-out',
            command: () => {
                keycloak?.logout();
            }
        }
    ];

    return (
        <>
            <SplitButton text label={keycloak.tokenParsed?.preferred_username} icon="pi pi-user"
                          model={items} severity="info" />
        </>
    );
}